import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import React, { useEffect } from 'react';

import { fetchOrders, setActive } from 'actions/orders';
import { fetchCouncils } from 'actions/councils';
import { fetchUsers } from 'actions/users';

import Orders from './Orders';
import { Container, InnerContain } from './OrdersStyled';
import useOrders from './useOrders';
import usePagination from './usePagination';
import { councilOrdersSelector } from 'selectors/orders';

export const OrdersContainer = ({
  beta,
  history,
  orders = [],
  fetchUsers,
  fetchOrders,
  fetchCouncils,
  ordersLoading,
  dispatchSetActive,
  ...props
}) => {
  useEffect(() => {
    fetchUsers();
    fetchOrders();
    fetchCouncils();
  }, [fetchOrders, fetchCouncils, fetchUsers]);

  const {
    activeQuery,
    activeFilter,
    handleSearch,
    activeQueryBy,
    handleSearchBy,
    handleStatusFilter,
    orders: ordersList
  } = useOrders(orders);

  const [renderPagination, pagedOrders, resetPage] = usePagination(
    ordersList,
    activeFilter
  );

  const handleFilterClick = (status) => {
    resetPage();
    handleStatusFilter(status);
  };

  const handleSearchChange = (name, value) => {
    resetPage();
    handleSearch(value);
  };

  const handleSearchByChange = (filterBy) => {
    resetPage();
    handleSearchBy(filterBy);
  };

  const handleOrderClick = (orderId) => {
    dispatchSetActive(orderId);
    history.push(`/orders/${orderId}`);
  };

  const handleCreateSearch = () => history.push('/orders/council');
  const handleCreateForm1 = () => history.push('/orders/form1');
  const handleStrataSearch = () => history.push('orders/strata');

  return (
    <Container>
      <InnerContain>
        {props.routeProps ? props.routeProps.notices : null}
        <Orders
          beta={beta}
          orders={pagedOrders}
          loading={ordersLoading}
          activeQuery={activeQuery}
          activeFilter={activeFilter}
          onSearch={handleSearchChange}
          activeQueryBy={activeQueryBy}
          onSearchBy={handleSearchByChange}
          onOrderClick={handleOrderClick}
          createForm1={handleCreateForm1}
          createSearch={handleCreateSearch}
          createStrata={handleStrataSearch}
          onFilterClick={handleFilterClick}
          renderPagination={renderPagination}
        />
      </InnerContain>
    </Container>
  );
};

const mapDispatchToProps = {
  fetchUsers,
  fetchOrders,
  fetchCouncils,
  dispatchSetActive: setActive
};

const mapStateToProps = (state) => ({
  orders: councilOrdersSelector(state),
  ordersLoading: state.loading.loadingOrders,
  beta: state.session.account && state.session.account.form1_beta
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(OrdersContainer)
);
